import {useParams} from 'react-router-dom'
import {Paper, Back, Loader} from 'common/components'
import OrgCard from "./components/OrgCard"
import MembersList from './components/MembersList'
import styles from './Details.module.scss'
import {useGetOrgDetails} from '.'
export default function Details() {
  const params = useParams()
  const {data: resBody} = useGetOrgDetails({
    uuid: params?.uuid
  })

  return (
    <Paper relative fullHeight>
      <Back to="/orgs" />
      { !resBody?.data ? <Loader /> :
        <div className={styles.root}>
          <OrgCard data={resBody.data} imgHeight={280} />
          <MembersList data={resBody.data} />
        </div>
      }
    </Paper>
  )
}
